import { api } from "@/lib/api-client"

export type SearchOptions = Partial<
  Record<string, Partial<Record<string, boolean | number | null>>>
>
export type SearchSettings = {
  revision: string
  instance_id: string
  stored: SearchOptions
  inherited: SearchOptions
  effective: SearchOptions
  sources: Record<string, Record<string, string>>
  inherited_sources: Record<string, Record<string, string>>
  bounds: Partial<Record<string, Partial<Record<string, [number, number, boolean]>>>>
}
export type EngineSetting = {
  key: string
  value: string | number
  default: string | number
  bounds: { min: number; max: number } | { allowed: string[] }
  effect: "immediate" | "restart" | "rederive"
  kill_switch_active: boolean
  cost_hint?: "none" | "background_rederive" | "restart_required"
}
export type EngineSettings = { revision: number; settings: EngineSetting[] }
export type EngineSave = {
  revision: number
  applied: Record<string, string | number>
  pending_effect: "immediate" | "restart" | "rederive"
}
export function searchSettingsEndpoint(id: string, library = false): string {
  return `/admin/${library ? "libraries" : "filth-backends"}/${encodeURIComponent(id)}/search-options`
}
export async function loadSearchSettings(id: string, library = false): Promise<SearchSettings> {
  const response = await api.get(searchSettingsEndpoint(id, library))
  return (response.data || response) as SearchSettings
}
export async function saveSearchSettings(
  id: string,
  input: { revision: string; options: SearchOptions },
  library = false
): Promise<SearchSettings> {
  const response = await api.put(searchSettingsEndpoint(id, library), input)
  return (response.data || response) as SearchSettings
}
export async function loadEngineSettings(id: string): Promise<EngineSettings> {
  const response = await api.get(`/admin/filth-backends/${encodeURIComponent(id)}/settings`)
  return (response.data || response) as EngineSettings
}
export async function saveEngineSettings(
  id: string,
  input: {
    revision: number
    changes: Record<string, string | number>
    confirm_cost?: boolean
    estimate_id?: string
  }
): Promise<EngineSave> {
  const response = await api.put(`/admin/filth-backends/${encodeURIComponent(id)}/settings`, input)
  return (response.data || response) as EngineSave
}
